<template>
	<section class="browse">
		<div class="browse__items">
			<ProductCard
				class="browse__item"
				v-for="product in products"
				:key="product.id"
				:item="product"
				:is-auth="isAuth"
				:chosen-item="chosenItem"
				@addToCart="(item) => $emit('addToCart', item)"
				@openProductModal="(id) => $emit('openProductModal', id)"
				@openCartModal="$emit('openCartModal')"
				@openLoginModal="$emit('openLoginModal')"
			/>
		</div>
		<router-link
			class="browse__more _btn-primary"
			:to="{
				name: 'ProductListPage',
				params: { itemType: 'all' },
				query: { types: randomType },
			}"
		>
			{{ $t('see more skins') }}
		</router-link>
	</section>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductCard from '../ProductCard.vue';

export default {
	name: 'BrowseItems',
	components: { ProductCard },
	props: {
		chosenItem: { type: String },
		isAuth: { type: Boolean, required: true },
	},
	data() {
		return {
			imgDomain: '',
			products: [],
			randomType: null,
		};
	},
	computed: {
		...mapGetters('app', ['currencyCode', 'currencySymbol']),
	},
	mounted() {
		this.randomType = null;
		this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
		this.fetchProducts();
	},
	watch: {
		currencyCode() {
			this.fetchProducts();
		},
	},
	methods: {
		openProductModal(id) {
			this.$emit('openProductModal', id);
		},
		addToCart(item) {
			this.$emit('addToCart', item);
		},
		fetchProducts() {
			const types = [
				'knife',
				'rifle',
				'pistol',
				'smg',
				'shotgun',
				'machinegun',
			];

			this.randomType = types[Math.floor(Math.random() * types.length)];

			this.$http
				.get(process.env.VUE_APP_API + 'items/list', {
					params: {
						type: this.randomType,
						random: true,
						limit: 10,
					},
				})
				.then((res) => {
					this.products = (res.data.payload || []).slice(0, 8);
				})
				.catch((err) => {
					if (err.response && err.response.status === 401) {
						this.openSignInModal?.();
					}
				});
		},
		getTitle(title) {
			if (!title) return '';

			let part = title.split('|')[1] || title;
			part = part.split('(')[0];

			return part.trim();
		},
		getType(title) {
			if (!title) return '';

			let part = title.split('|')[0];
			part = part.replace(/^(StatTrak™|Souvenir)\s+/i, '');

			return part.trim();
		},
	},
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/fonts' as *;
@use '@/assets/styles/components/classes' as *;

.browse {
	@include adaptiveValue('padding-top', 145, 25);
	@include adaptiveValue('padding-bottom', 100, 25);
	&__items {
		display: flex;
		flex-wrap: wrap;
		column-gap: 20px;
		row-gap: 35px;
		height: fit-content;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 55, 20);
		}
		@media (max-width: $md2) {
			column-gap: 10px;
			row-gap: 25px;
		}
		@media (max-width: 649.98px) {
			margin: 0px - 10px;
			column-gap: 6px;
			row-gap: 6px;
		}
	}
	&__item {
		flex: 0 1 calc(25% - 15px);
		max-height: 100%;
		@media (max-width: $md2) {
			flex: 0 1 calc(33.333% - 6.7px);
		}
		@media (max-width: 649.98px) {
			flex: 0 1 calc(50% - 3px);
		}
	}
	&__more {
		max-width: 224px;
		margin: 0 auto;
		min-height: 40px;
		@media (max-width: $md6) {
			max-width: 100%;
		}
	}
}
</style>
